import { render, staticRenderFns } from "./HospitalizationReport.vue?vue&type=template&id=7209c15e&scoped=true&"
import script from "./HospitalizationReport.vue?vue&type=script&lang=js&"
export * from "./HospitalizationReport.vue?vue&type=script&lang=js&"
import style0 from "./HospitalizationReport.vue?vue&type=style&index=0&id=7209c15e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7209c15e",
  null
  
)

export default component.exports